<template>
	<div
		v-if="isOpen"
		class="fixed left-0 bottom-0 w-screen z-20 bg-purple-900"
	>
		<div
			v-show="isContentOpen"
			id="molecule-dialog-bottom"
			class="relative max-h-svh overflow-auto overflow-x-clip hide-scrollbars container text-white"
		>
			<div
				v-if="isClosable"
				class="flex justify-end pt-8"
			>
				<button
					title="Sluiten"
					@click="close"
				>
					<LazyAtomFontAwesome
						icon="fa-xmark"
						class="w-8 h-8 text-gray-400"
					/>
				</button>
			</div>
			<slot />
		</div>
	</div>
</template>

<script lang="ts" setup>
const {
	isOpen = false,
	isClosable = true,
} =	defineProps<{
	isOpen?: boolean;
	isClosable?: boolean;
}>();

const isContentOpen = ref(true);

watch(
	() => isOpen, (isOpen) => {
		if (isOpen) {
			// Opening on query didn't open content, so content is now open by default
			// it's closed and then reopened for the animation when manually opened.
			isContentOpen.value = false;
			setTimeout(() => {
				isContentOpen.value = true;
			}, 150);
		}
	}
);

const emit = defineEmits(['close']);
const close = () => {
	isContentOpen.value = false;
	setTimeout(() => {
		emit('close');
	}, 100);
};
</script>
